import type { RuleTemplate, StringConst } from '../../../../../interfaces/Interfaces';
import { ACTION_TYPE, CASE_ATTRIBUTE, CONTRACT_STATUS, OPERATOR } from '../../../../../interfaces/enums';
import { ValidationResult } from '../../../../DunningSelectionPage/DunningSelection/input/Validators';

function isValidContractStatusCondition(
  cmp: string,
  val: string,
): boolean {
  if (cmp === OPERATOR.EQ) {
    return val === CONTRACT_STATUS.ACTIVE;
  }

  if (cmp === OPERATOR.NEQ) {
    if (val === CONTRACT_STATUS.TERMINATED || val === CONTRACT_STATUS.EXPIRED) {
      return true;
    }
    // Handle comma-separated values in any order
    const values = val.split(',').map(v => v.trim());
    return (
      values.length === 2 &&
      values.includes(CONTRACT_STATUS.TERMINATED) &&
      values.includes(CONTRACT_STATUS.EXPIRED)
    );
  }

  return false;
}

export function validateConditionIfTerminationAction(ruleEdit: RuleTemplate): ValidationResult | null {
  if (ruleEdit.actions.some(action => action['@type'] === ACTION_TYPE.CONTRACT_TERMINATION)) {
    const statusConditions = ruleEdit.caseConditions.filter(
      condition => condition.attrib === CASE_ATTRIBUTE.CONTRACT_STATUS,
    );

    if (statusConditions.length === 0) {
      return {
        error: true,
        message: 'error.rule-editor.missing-contract-termination-cond',
      };
    }

    if (statusConditions.length > 1) {
      return {
        error: true,
        message: 'error.rule-editor.multiple-choices-impossible',
      };
    }

    if (statusConditions.length === 1) {
      const condition = statusConditions[0];
      const conditionValue = (condition.argument as StringConst).val;

      if (!isValidContractStatusCondition(condition.cmp, conditionValue)) {
        return {
          error: true,
          message: 'error.rule-editor.contract-already-terminated-cond',
        };
      }
    }
  }
  return null;
}
